import { Box, Button, Dialog, Stack, Typography } from '@mui/material';
import React from 'react';

import { CopyableCode } from '../shared/copyableCode';
import { Icon } from '../shared/icon';
import { ContactSupportButton } from '../support/support';

export function ErrorDialog({
  isOpen,
  title,
  description,
  onClose,
  error,
}: {
  isOpen: boolean;
  title: string;
  description?: React.ReactNode;
  onClose: () => void;
  error?: string | Error;
}) {
  const errorMessage = error && error instanceof Error ? error.message : error;
  const errorCode =
    error && error instanceof Error && 'errorCode' in error
      ? (error.errorCode as string)
      : undefined;

  return (
    <Dialog
      open={isOpen}
      slotProps={{
        paper: {
          sx: {
            width: 'max-content',
            maxWidth: '840px',
            minWidth: '600px',
            height: 'max-content',
            maxHeight: '90vh',
            borderRadius: '16px',
          },
        },
      }}
    >
      <Stack data-testid='error-dialog'>
        <Stack
          direction='row'
          justifyContent='end'
          alignItems='center'
          padding='16px 24px'
          paddingBottom='0'
        >
          <Icon onClick={onClose} iconClass='material-symbols-close-rounded' />
        </Stack>
        <Stack
          alignItems='center'
          gap='24px'
          sx={{ px: '40px', textAlign: 'center', pb: '40px' }}
        >
          <Box
            component={'span'}
            className='rounded-full inline-flex p-[2px]'
            sx={{
              background: 'var(--mui-palette-error-opacity)',
            }}
          >
            <i
              className={`material-symbols-cancel-outline h-[20px] w-[20px] bg-(--mui-palette-error-main)`}
            />
          </Box>
          <Typography variant='h2'>{title}</Typography>
          {description && (
            <Typography
              maxWidth='70%'
              variant='body1'
              className='mb-[12px]'
              lineHeight={'20px'}
              sx={{
                wordBreak: 'break-word',
              }}
            >
              {description}
            </Typography>
          )}
          {errorMessage && (
            <Stack minWidth='70%' marginX='40px'>
              <CopyableCode
                title={`Error message ${errorCode || ''}`}
                code={errorMessage}
                codeClassName='whitespace-pre-wrap text-start font-bold'
                variant='error'
              />
            </Stack>
          )}
          <Stack direction='row' gap='16px'>
            <Button onClick={onClose} variant='text'>
              Close
            </Button>
            <ContactSupportButton />
          </Stack>
        </Stack>
      </Stack>
    </Dialog>
  );
}
